<!-- Mevcut iframe kodunu bu komponente değiştir -->
<template>
  <div class="video-container">
    <div
        class="video-thumbnail"
        :style="{ backgroundImage: thumbnailUrl }"
        @click="openVideo"
    >
      <div class="video-overlay">
        <div class="play-button">
          <div class="play-icon"></div>
        </div>
      </div>
      <div class="video-title">
        {{ thumbnailError ? 'Hata' : 'Video İzlemek İçin Tıklayın' }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'YouTubeClickToLoad',
  props: {
    videoId: {
      type: String,
      default: 'dQw4w9WgXcQ' // Rick Roll - her zaman çalışır :)
    }
  },
  data() {
    return {
      thumbnailError: false
    }
  },
  computed: {
    thumbnailUrl() {
      if (this.thumbnailError) {
        // Fallback: YouTube play button with gradient
        return 'linear-gradient(135deg, #ff0000, #cc0000)';
      }
      return `url(https://img.youtube.com/vi/${this.videoId}/maxresdefault.jpg)`;
    }
  },
  methods: {
    openVideo() {
      // YouTube videoyu yeni sekmede aç
      const url = `https://www.youtube.com/watch?v=${this.videoId}`;
      window.open(url, '_blank');
    },
    handleThumbnailError() {
      this.thumbnailError = true;
    }
  },
  mounted() {
    // Thumbnail yüklenip yüklenmediğini kontrol et
    const img = new Image();
    img.onload = () => {
      this.thumbnailError = false;
    };
    img.onerror = () => {
      this.thumbnailError = true;
    };
    img.src = `https://img.youtube.com/vi/${this.videoId}/maxresdefault.jpg`;
  }
}
</script>

<style scoped>
.video-container {
  position: relative;
  width: 100%;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  background: #000;
}

.video-thumbnail {
  position: relative;
  width: 100%;
  height: 315px;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}

.video-thumbnail:hover {
  transform: scale(1.02);
}

.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0.3));
  display: flex;
  align-items: center;
  justify-content: center;
}

.play-button {
  width: 80px;
  height: 56px;
  background: rgba(255, 0, 0, 0.9);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.play-icon {
  width: 0;
  height: 0;
  border-left: 20px solid white;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  margin-left: 4px;
}

.video-thumbnail:hover .play-button {
  background: #ff0000;
  transform: scale(1.1);
}

.video-title {
  position: absolute;
  bottom: 20px;
  left: 20px;
  right: 20px;
  color: white;
  font-family: Arial, sans-serif;
  font-size: 16px;
  font-weight: bold;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.8);
}

.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 315px;
  color: white;
  font-family: Arial, sans-serif;
  background: #000;
}

</style>